import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "question-label" }
const _hoisted_2 = {
  key: 0,
  class: "text-3xl -mt-12 mb-14"
}
const _hoisted_3 = { class: "question-user-information" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-red-500 text-2xl font-bold text-center" }
const _hoisted_6 = { class: "flex justify-between mt-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.2299 1.24994L11.2299 14.7499C11.2295 14.8866 11.1918 15.0206 11.1209 15.1374C11.05 15.2543 10.9486 15.3496 10.8275 15.4131C10.7065 15.4766 10.5704 15.5059 10.434 15.4978C10.2975 15.4897 10.1659 15.4445 10.0532 15.3672L0.303188 8.61719C-0.101062 8.33744 -0.101062 7.66394 0.303188 7.38344L10.0532 0.633442C10.1656 0.55531 10.2974 0.509492 10.434 0.500965C10.5707 0.492439 10.7071 0.521529 10.8284 0.585077C10.9497 0.648625 11.0513 0.744198 11.122 0.861415C11.1928 0.978631 11.2302 1.11301 11.2299 1.24994Z",
    fill: "black"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.750044 1.24994L0.750043 14.7499C0.750471 14.8866 0.788168 15.0206 0.859077 15.1374C0.929984 15.2543 1.03142 15.3496 1.15246 15.4131C1.2735 15.4766 1.40956 15.5059 1.546 15.4978C1.68245 15.4897 1.8141 15.4445 1.92679 15.3672L11.6768 8.61719C12.081 8.33744 12.081 7.66394 11.6768 7.38344L1.92679 0.633442C1.81434 0.55531 1.68262 0.509492 1.54595 0.500965C1.40928 0.492439 1.27289 0.521529 1.15159 0.585077C1.03029 0.648625 0.928728 0.744198 0.857935 0.861415C0.787143 0.978631 0.749827 1.11301 0.750044 1.24994Z",
    fill: "white"
  })
], -1)

import { watch, ref, computed, onMounted, nextTick } from "vue";
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInputQuestion',
  props: {
    field: Object,
    fieldIndex: Number,
    currentIndex: Number,
},
  emits: ["previousPage", "nextPage"],
  setup(__props, { emit }) {

const props = __props;



const fieldHtml = ref();
const fieldValue = ref();
const showErrorMessage = ref(false);

const toggleOtherClass = (otherField, otherInput) => {
    if (otherField.checked) {
        otherInput.classList.remove('hidden');
    } else {
        otherInput.classList.add('hidden');
    }
}
 
watch(() => props.currentIndex, () => {
    if (props.currentIndex === props.fieldIndex) {
        const otherField = fieldHtml.value.querySelector('input[value="Other"]');
        const otherInput = document.querySelector('.hidden-field-conditions-other');
        if (otherField && otherInput) {
            if (!otherField.classList.contains('input-change-event')) {
                otherField.classList.add('input-change-event');
                otherField.addEventListener('change', () => {
                    toggleOtherClass(otherField, otherInput);
                });
            }

            toggleOtherClass(otherField, otherInput);
        } else {
            otherInput.classList.add('hidden');
        }
    }
});

onMounted(() => {
    nextTick(() => {
        if (fieldHtml.value) {
            const list = fieldHtml.value.querySelector('ul');
            if (list) {
                const listItems = list.querySelectorAll('li');

                if (listItems.length > 5) {
                    list.classList.add('multi-column');
                }
            }
        }
    });
});


const isValid = () => {
    if (!fieldHtml.value) {
        return false;
    }

    if (props.field.type !== 'radio' && props.field.type !== 'checkbox') {
        return true;
    }
    const inputs = fieldHtml.value.querySelectorAll('input');
    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) {
            return true;
        }
    }
    return false;
}



const back = () => {
    showErrorMessage.value = false;
    emit('previousPage');
};

const next = () => {
    if (isValid()) {
        showErrorMessage.value = false;
        emit('nextPage');
    } else {
        showErrorMessage.value = true;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.field.label) + " " + _toDisplayString(fieldValue.value), 1),
      (__props.field.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.field.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          ref_key: "fieldHtml",
          ref: fieldHtml,
          innerHTML: __props.field.html
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, "Please choose an option to continue", 512), [
      [_vShow, showErrorMessage.value]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(SecondaryButton, { onClick: back }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" Back ")
        ]),
        _: 1
      }),
      _createVNode(PrimaryButton, { onClick: next }, {
        default: _withCtx(() => [
          _createTextVNode(" Next "),
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}
}

})